import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Container, Table } from "reactstrap"
import reportIMG from "../../assets/images/report1.png"
import noreportIMG from "../../assets/images/noReport.jpg"
import { fetchData } from "utils/Common_api_functions"
import moment from "moment"
import { formatAnyTime } from "utils/commonFunctions"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const getTotalMinutes = (start, end) => {
  if (!start || !end) return 0

  const parse = time => {
    if (!time) return null

    const is12 = /am|pm/i.test(time)
    let h, m

    if (is12) {
      const [t, ap] = time.split(" ")
      ;[h, m] = t.split(":").map(Number)
      if (ap.toLowerCase() === "pm" && h < 12) h += 12
      if (ap.toLowerCase() === "am" && h === 12) h = 0
    } else {
      ;[h, m] = time.split(":").map(Number)
    }

    return h * 60 + (m || 0)
  }

  let startMin = parse(start)
  let endMin = parse(end)

  if (endMin < startMin) endMin += 1440 // next day

  return endMin - startMin
}

const Reports = () => {
  const [loading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState("")
  const [selectedLocation, setSelectedLocation] = useState("")
  const [selectedEmployee, setSelectedEmployee] = useState("")

  const [allData, setAllData] = useState([])
  const [events, setEvents] = useState([])
  const [timeSheets, settimesheets] = useState([])

  const uniqueLocations = [
    ...new Map(
      allData.map(e => [
        e.locationId,
        { id: e.locationId, name: e.location?.name },
      ])
    ).values(),
  ]

  console.log(allData)

  const uniqueEmployees = [
    ...new Map(
      allData.map(e => [
        e.employeeId,
        {
          id: e.employeeId,
          name: e.employee?.name,
          profilePicture: e.employee?.profilePicture,
        },
      ])
    ).values(),
  ]

  useEffect(() => {
    if (selectedDate) {
      getEvents()
    }
  }, [selectedDate])

  async function getEvents() {
    const APIdata = await fetchData(
      setLoading,
      `dashboard/counts?date=${moment(selectedDate)?.format("YYYY-MM-DD")}`
    )
    if (APIdata?.success) {
      setAllData(APIdata?.events)
      setEvents(APIdata?.events)
      settimesheets(APIdata?.timesheets)
    } else {
      setAllData([])
      setEvents([])
      settimesheets([])
    }
  }

  useEffect(() => {
    let filteredData = allData

    // 🔹 Filter by Location
    if (selectedLocation) {
      filteredData = filteredData.filter(
        item => item?.locationId === Number(selectedLocation)
      )
    }

    // 🔹 Filter by Employee
    if (selectedEmployee) {
      filteredData = filteredData.filter(
        item => item?.employeeId === Number(selectedEmployee)
      )
    }

    setEvents(filteredData)
  }, [selectedLocation, selectedEmployee, allData])

  const { checkAccess } = usePermissionData()

  const calculateTotalHours = (start, end) => {
    if (!start || !end) return ""

    let startDate, endDate

    // Helper to parse time string
    const parseTime = timeStr => {
      if (!timeStr) return null

      let hours, minutes

      // Check if string contains AM/PM
      const is12Hour = /am|pm/i.test(timeStr.trim())

      if (is12Hour) {
        // Example: "2:30 PM"
        const [timePart, ampm] = timeStr.trim().split(" ")
        let [h, m] = timePart.split(":").map(Number)
        if (ampm.toLowerCase() === "pm" && h < 12) h += 12
        if (ampm.toLowerCase() === "am" && h === 12) h = 0
        hours = h
        minutes = m || 0
      } else {
        // 24-hour format "14:30" or "9:05"
        const [h, m] = timeStr.split(":").map(Number)
        hours = h
        minutes = m || 0
      }

      const date = new Date()
      date.setHours(hours, minutes, 0, 0)
      return date
    }

    // Determine startDate
    if (start instanceof Date) startDate = new Date(start)
    else if (typeof start === "string") startDate = parseTime(start)

    // Determine endDate
    if (end instanceof Date) endDate = new Date(end)
    else if (typeof end === "string") endDate = parseTime(end)

    if (!startDate || !endDate) return ""

    // If end is earlier than start → next day
    if (endDate < startDate) endDate.setDate(endDate.getDate() + 1)

    const diffMs = endDate - startDate
    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60))
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

    return `${diffHrs}h ${diffMins}m`
  }

  return (
    <div className="page-content">
      <PermittedComponent isAccess={checkAccess(8, 1) || checkAccess(8, 2)}>
        {loading && <Loader />}
        <Container fluid>
          <Breadcrumb
            title={"Reports"}
            breadcrumbItem={"Daily Report"}
            description={"View and Check Reports of Individual Day"}
          />

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-5">
                <h4>Daily Reports</h4>
                <div className="d-flex gap-3">
                  <div className="d-block">
                    <h6>Select Date</h6>
                    <input
                      className="form-control"
                      type="date"
                      value={selectedDate}
                      onChange={e => setSelectedDate(e.target.value)}
                      style={{ width: "160px" }}
                    ></input>
                  </div>
                  <div>
                    <h6>Select Location</h6>
                    <select
                      className="form-select w-auto rounded-4 py-2 pe-5"
                      value={selectedLocation}
                      onChange={e => setSelectedLocation(e.target.value)}
                    >
                      <option value="">All Locations</option>
                      {uniqueLocations.map(emp => (
                        <option key={emp.id} value={emp.id}>
                          {emp.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <h6>Select Employee</h6>
                    <select
                      className="form-select w-auto rounded-4 py-2 pe-5"
                      value={selectedEmployee}
                      onChange={e => setSelectedEmployee(e.target.value)}
                    >
                      <option value="">All Employee</option>
                      {uniqueEmployees
                        .filter(i => i.id)
                        .map(emp => (
                          <option key={emp.id} value={emp.id}>
                            {emp.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              {!selectedDate && (
                <div className="d-flex flex-column align-items-center">
                  <img src={reportIMG} height={350} />
                  <h4>Daily Reports are Ready.</h4>
                  <p>Select Date to View Reports.</p>
                </div>
              )}

              {selectedDate && events?.length === 0 && (
                <div className="d-flex flex-column align-items-center">
                  <img src={noreportIMG} height={350} />
                  <h5>No Data Found on This Date or Seleted Location.</h5>
                </div>
              )}

              {selectedDate && events?.length > 0 && (
                <Table responsive bordered>
                  <thead className="bg-blue">
                    <tr>
                      <th>Sr No.</th>
                      <th>Location Name</th>
                      <th>Employee Name</th>
                      <th>Planned Time</th>
                      <th>Actual Time</th>
                      <th>Total Working Hours</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events?.map((event, index) => {
                      // Find the matching timesheet
                      const matchedTimesheet = timeSheets?.find(
                        ts => ts?.calenderSlotId === event?.id
                      )

                      // Determine final status
                      let finalStatus = "Pending"

                      if (matchedTimesheet) {
                        finalStatus = "Completed"
                      } else if (event?.status !== "Available") {
                        finalStatus = event?.status
                      }

                      // ⏱ Planned & Actual minutes
                      const plannedMinutes = getTotalMinutes(
                        event?.inTime,
                        event?.outTime
                      )

                      const actualMinutes = matchedTimesheet
                        ? getTotalMinutes(
                            matchedTimesheet?.inTime,
                            matchedTimesheet?.outTime
                          )
                        : 0

                      let rowStyle = {}

                      // 🔴 Pending
                      if (!matchedTimesheet) {
                        rowStyle = {
                          backgroundColor: "#f46a6a",
                          color: "white",
                        }
                      }
                      // 🟡 Less than planned
                      else if (actualMinutes < plannedMinutes) {
                        rowStyle = {
                          backgroundColor: "#f1b44c",
                          color: "black",
                        }
                      }
                      // 🟢 Proper
                      else {
                        rowStyle = {
                          backgroundColor: "#34c38f",
                          color: "white",
                        }
                      }

                      return (
                        <tr key={index} style={rowStyle}>
                          <td>{index + 1}</td>
                          <td>{event?.location?.name}</td>
                          <td>{event?.employee?.name}</td>
                          <td>
                            {formatAnyTime(event?.inTime)} -{" "}
                            {formatAnyTime(event?.outTime)}
                          </td>
                          <td>
                            {formatAnyTime(matchedTimesheet?.inTime)} -{" "}
                            {formatAnyTime(matchedTimesheet?.outTime)}
                          </td>
                          <td>
                            {calculateTotalHours(
                              matchedTimesheet?.inTime,
                              matchedTimesheet?.outTime
                            ) || "--"}
                          </td>
                          <td>{finalStatus}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Container>
      </PermittedComponent>
    </div>
  )
}

export default Reports
